import React, { useEffect } from 'react'
import HomeTop from './HomeTop'
import HomeFooter from './HomeFooter'
import { Button, Grid } from '@mui/material'
// import { useNavigate } from 'react-router-dom';


function GuardFeatures() {
    // const navigate = useNavigate();

     useEffect(() => {
                window.scrollTo(0, 0); // Scroll to top on component mount
              }, []);

  return (
    
    <>
    <HomeTop />

    <div className='adminBannerMain whiteBG'>
        <div className='container'>
            <div className='adminBannerContent'>
            <div className='adminBannerContent'>
            <h1>Security Applications</h1>
            <p>The Guard module in a ResiPro facilitates efficient management of security personnel and gatekeeping operations. It includes features for visitor management, gate pass issuance, incident reporting, and real-time monitoring of entry and exit logs, ensuring enhanced security and streamlined access control within the community.</p>
        </div></div>
        </div>
    </div>

    <div className='sectionMain'>
        <div className='innerPagesFeaturesOuter'>
            <div className='container'>
                <div className='innerPagesFeaturesInner'>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <div className='featureOuter'>
                                <h3>Clock In/Clock Out</h3>
                                <p>Clock In/Clock Out when duty starts and duty ends.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className='featureOuter'>
                                <h3>Visitor Management</h3> 
                                <p>Capture visitor information such as Photo, Name, Number, Email Id, Visiting Purpose and send for approval to the Residents.</p>
                             
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <div className='featureOuter'>
                                <h3>Notifications</h3>
                                <p>Get important notifications related to the society.</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div className='featureOuter'>
                                <h3>SOS</h3>
                                <p>Raise alerts in case of emergencies.</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>

    </div>

    <div className='contactFormMain'>
        <div className='sectionMain'>
            <div className='container'>
                <div className='contactForm'>
                    <h1 className='sectionHeading' style={{ color: '#ffffff' }}>Connect With Us</h1>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Enter name"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Enter mobile number"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Enter email id"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Enter society name"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Select Location"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <input
                                className="contactInput"
                                placeholder="Enter City"
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Button className='contactBtn'>Submit</Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    </div>

    <HomeFooter />
</>

)
}

export default GuardFeatures